// Single source of truth for the OS-level "reduce motion" preference.
// When true, all scroll animations are disabled and content renders in its
// final, fully-visible state — no fades, slides, parallax, or smooth scroll.
export const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
